const getPmcById = (state, pmcId) => state?.pmcs?.[pmcId] || {};

const getPmcsList = (state) => {
  const pmcs = state?.pmcs || [];
  if (Array.isArray(pmcs)) return pmcs;
  if (Object.values(pmcs).length) return Object.values(pmcs);
  return [];
};

const getPmcStaffById = (state, pmcId, staffId) =>
  getPmcById(state, pmcId)?.personDetails?.[staffId] || {};

export { getPmcById, getPmcsList, getPmcStaffById };
